import React, {useState} from "react"
import * as styles from "./bio.module.css"
import Section from "./section"

export default function Bio() {
	const [isExpanded, setIsExpanded] = useState(false)

	const toggleReadMore = () => {
		setIsExpanded(!isExpanded)
	}

	return (
		<Section id="about" className={styles.bio}>
			<h3>Nate connects people to stories that matter</h3>
			{/*!!!
				NOTE: If you change any of this, consider updating the meta description tag
				on the index page
				!!!!
				*/}
			<p>
				<strong>Nate Weiner</strong> (Wine-er) is a Minneapolis-based composer
				whose career has been built on connecting people to stories that matter.
				Best known as the <strong>Founder and CEO of Pocket</strong> (acquired
				by Mozilla), he helped over <strong>50 million monthly users</strong>{" "}
				discover and consume valuable content, earning recognition on{" "}
				<strong>Time Magazine's 30 Under 30 "World Changers"</strong> list.
				Following his role as <strong>SVP at Mozilla</strong>, Nate embarked on
				a new chapter.
			</p>

			<p>
				Now studying at <strong>Berklee College of Music</strong>, Nate is
				returning to a lifelong passion: music for film, TV, and video games — a
				continuation of his work on connecting people to stories.
			</p>

			<p>
				Nate's experience in creating apps users love translates seamlessly into
				his approach to composition. His ability to deeply understand users'
				needs, focus on delightful details, and craft narratives across entire
				experiences led Pocket to earn a{" "}
				<strong>Google Material Design Award</strong> and a{" "}
				<strong>Webby Award for Best User Experience</strong>. He now applies
				these same principles to his compositions. This unique background
				bridges the worlds of technology and music, offering filmmakers and game
				developers a composer who understands both the technical and emotional
				aspects of storytelling.
			</p>
			{/* 
			<div>
				<a onClick={toggleReadMore} className={styles.readMoreToggle}>
					{isExpanded ? "▼" : "▶"} Read more about why Nate is shifting from
					tech into music
				</a>
				<div
					className={`${styles.expandableContent} ${
						isExpanded ? styles.expanded : ""
					}`}
				>
					<p>
						I've always been captivated by the power of scores. Since I was a
						kid, they've been my primary musical companion, possessing what
						seemed like a superpower to evoke emotion and connect me to stories
						I cared about. Even in my early days of making home movies and silly
						skits with friends, my favorite part was finding the perfect music
						to elevate our amateur productions, lending gravity to even the most
						ridiculous scenes.
					</p>

					<p>
						While I've always had one foot in the tech world—programming since I
						was young and constantly hacking on new ideas—my obsession over
						visual storytelling led me to drop out of college to pursue a career
						in 3D animation. For a while, I even considered film school. Then
						life threw me a curveball. Pocket, one of my side projects at the
						time, unexpectedly took off, and I found myself on a different
						journey in the tech industry.
					</p>

					<p>
						13 years later, after leaving my role at Pocket/Mozilla, I felt
						drawn back to my first love. I decided to study into composition,
						eager to understand the mechanics behind the music that had shaped
						my life. What started as curiosity quickly blossomed into passion.
						To my surprise, composing music worked in my head in ways similar to
						coding and product development. Each piece presented a puzzle, each
						scene a problem to solve. I realized that creating a compelling
						score isn't so different from building a great app. Both require a
						deep understanding of the user's story—the emotions, feelings, and
						needs of the people involved.
					</p>

					<p>
						Embarking on music composition full-time, feels like returning to a
						childhood dream. In many ways, it's a natural extension of my work
						at Pocket. There, we strived to elevate important stories, articles,
						and videos, focused on how it impacted people: How it made them
						grow, think or even cry. Now, I'm embracing a new kind of
						storytelling, but the end goal remains the same: to connect people
						with stories that matter.
					</p>
				</div>
			</div>*/}
		</Section>
	)
}
